import { Notification, NotificationBuilder, NotificationType } from '@ca/core/models';
import { TranslateService } from '@ngx-translate/core';
import { getLeftNumberOfDays, getNewDate, getNewDateFormatted } from '../../../../utils/date/date-utils';

export class SubscriptionEndsNotificationBuilder implements NotificationBuilder {
    type: NotificationType;
    private endDate: string;
    private threshold: number;

    constructor(private translateService: TranslateService) {}

    setEndDate(value: string): this {
        this.endDate = value;
        return this;
    }

    setType(value: NotificationType): this {
        this.type = value;
        return this;
    }

    setThreshold(value: number): this {
        this.threshold = value;
        return this;
    }

    getType(): NotificationType {
        return this.type;
    }

    build(isTrial: boolean = false): Notification {
        const daysLeft: number = getLeftNumberOfDays(getNewDate().startOf('day'), getNewDate(this.endDate).startOf('day'));

        const title: string = this.translateService.instant(
            daysLeft > 1
                ? isTrial
                    ? 'NOTIFICATIONS.TRIAL_PERIOD_ENDS'
                    : 'NOTIFICATIONS.SUBSCRIPTION_PERIOD_ENDS'
                : daysLeft === 1
                  ? isTrial
                      ? 'NOTIFICATIONS.TRIAL_PERIOD_ENDS_TOMORROW'
                      : 'NOTIFICATIONS.SUBSCRIPTION_PERIOD_ENDS_TOMORROW'
                  : daysLeft === 0
                    ? isTrial
                        ? 'NOTIFICATIONS.TRIAL_PERIOD_ENDS_TODAY'
                        : 'NOTIFICATIONS.SUBSCRIPTION_PERIOD_ENDS_TODAY'
                    : isTrial
                      ? 'NOTIFICATIONS.TRIAL_PERIOD_ENDED'
                      : 'NOTIFICATIONS.SUBSCRIPTION_PERIOD_ENDED',
            { days: daysLeft },
        );

        const text: string = this.translateService.instant('NOTIFICATIONS.END_DATE', { date: getNewDateFormatted('DD.MM.YYYY', this.endDate) });

        const notification: Notification = {
            title,
            text,
            severity: daysLeft < 0 ? 'alert' : 'warn',
            type: this.type,
            createdAt: new Date(),
        };

        return notification;
    }

    shouldBuildNotification(): boolean {
        const daysLeft: number = getLeftNumberOfDays(getNewDate().startOf('day'), getNewDate(this.endDate).startOf('day'));
        return daysLeft <= this.threshold;
    }
}
